import { defineMessages } from 'react-intl'

export default defineMessages({
    title: {
        id: 'containers.CustomerPage.CustomerInfo.components.ErrorRates.title',
        defaultMessage: 'Error rates',
    },
    externalErrorRateLabel: {
        id: 'containers.CustomerPage.CustomerInfo.components.ErrorRates.externalErrorRateLabel',
        defaultMessage: 'External error rate',
    },
    internalErrorRateLabel: {
        id: 'containers.CustomerPage.CustomerInfo.components.ErrorRates.internalErrorRateLabel',
        defaultMessage: 'Internal  error rate',
    },
    totalErrorRateLabel: {
        id: 'containers.CustomerPage.CustomerInfo.components.ErrorRates.totalErrorRateLabel',
        defaultMessage: 'Total error rate',
    },
    loading: {
        id: 'containers.CustomerPage.CustomerInfo.components.ErrorRates.loading',
        defaultMessage: 'Loading error rates',
    },
    statTitle: {
        id: 'containers.CustomerPage.CustomerInfo.components.ErrorRates.statTitle',
        defaultMessage: '{totalOrdersWithIncidents} out of {totalOrders} orders',
    }
})